/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: niz-kpbuqS9M
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import AppShell from "../../AppShell"; // plasmic-import: Vh273IDurq9t/component
import WebTab from "../../WebTab"; // plasmic-import: XNSjqwwbHvXu/component
import WebTopNav from "../../WebTopNav"; // plasmic-import: tGgk6oqzsXGR/component
import Breadcrumb from "../../Breadcrumb"; // plasmic-import: k0sjE64BjPfV/component
import ButtonSecondary from "../../ButtonSecondary"; // plasmic-import: yzRkzInaRral/component
import ProgressBar from "../../ProgressBar"; // plasmic-import: eWV8ME8zaoyc/component
import NativeContainer from "../../NativeContainer"; // plasmic-import: dotM4jJPGxS5/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: cGXW91A7jag-/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: mqAYXqPyOASe/component
import FormElement from "../../FormElement"; // plasmic-import: ncxDEJ0p8q40/component
import InputField from "../../InputField"; // plasmic-import: pjd8dJIhANlZ/component
import RadioGroup from "../../RadioGroup"; // plasmic-import: CC1Zc4zA70UQ/component
import RadioOption from "../../RadioOption"; // plasmic-import: xChsQsS-PpI3/component
import RadioButtonSeparateComp from "../../RadioButtonSeparateComp"; // plasmic-import: V8_h9FeODS8h/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebSignupTemp.module.css"; // plasmic-import: niz-kpbuqS9M/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    title: "o21p signup.",
    openGraph: {
      title: "o21p signup."
    },
    twitter: {
      card: "summary",
      title: "o21p signup."
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWebSignupTemp__VariantProps = new Array();

export const PlasmicWebSignupTemp__ArgProps = new Array();

const $$ = {};

function PlasmicWebSignupTemp__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "onboardingContainer.container",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "withForm"
      },
      {
        path: "firstNameVariant",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "lastNameVariant",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "emailVariant",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "firstNameHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "lastNameHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "emailHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "firstNameHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "variable",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "lastNameHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "emailHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "firstNameInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "lastNameInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "emailInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "isCheckedYes",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "isCheckedNo",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "showTitleCredentials",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "yesClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "noClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "firstNameValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "lastNameValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "lastNameCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "firstNameCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "lastNameCheck2",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "showFormStatus",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "emailCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      },
      {
        path: "emailValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "yesNoError",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => "normal"
      },
      {
        path: "yesNoHelperText",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => ""
      },
      {
        path: "yesNoHelperTextOn",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "yesNoClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"page"}
        data-plasmic-override={overrides.page}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.page
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <WebTab
              data-plasmic-name={"webTab"}
              data-plasmic-override={overrides.webTab}
              className={classNames("__wab_instance", sty.webTab)}
              dockSection={false}
              tabContent={
                <React.Fragment>
                  <ProgressBar
                    data-plasmic-name={"progressBar"}
                    data-plasmic-override={overrides.progressBar}
                    className={classNames("__wab_instance", sty.progressBar)}
                  />

                  <NativeContainer
                    data-plasmic-name={"onboardingContainer"}
                    data-plasmic-override={overrides.onboardingContainer}
                    buttonsWrapper={
                      <React.Fragment>
                        <ButtonPrimary
                          className={classNames(
                            "__wab_instance",
                            sty.buttonPrimary__eZp5Y
                          )}
                          color={"brand"}
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToPWorkspace"] = true
                              ? (() => {
                                  const actionArgs = {
                                    destination: `/aaa/workspace`
                                  };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToPWorkspace"] != null &&
                              typeof $steps["goToPWorkspace"] === "object" &&
                              typeof $steps["goToPWorkspace"].then ===
                                "function"
                            ) {
                              $steps["goToPWorkspace"] =
                                await $steps["goToPWorkspace"];
                            }
                          }}
                        />

                        {false ? (
                          <ButtonPrimary
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPrimary__nVxNe
                            )}
                          />
                        ) : null}
                      </React.Fragment>
                    }
                    className={classNames(
                      "__wab_instance",
                      sty.onboardingContainer
                    )}
                    container={generateStateValueProp($state, [
                      "onboardingContainer",
                      "container"
                    ])}
                    formHeader={
                      "leave your details and we\u2019ll let you know when it\u2019s ready."
                    }
                    formWrapper={
                      <InputFormShell
                        data-plasmic-name={"inputFormShell"}
                        data-plasmic-override={overrides.inputFormShell}
                        actionsSlot={
                          <ButtonPrimary
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPrimary__wFtsp
                            )}
                            color={"brand"}
                            content={"notify me"}
                            name={``}
                            onClick={async () => {
                              const $steps = {};
                              $steps["runCode"] = true
                                ? (() => {
                                    const actionArgs = {
                                      customFunction: async () => {
                                        return (() => {
                                          console.log("butonul functioneaza");
                                          const input2 =
                                            document.getElementById(
                                              "firstName"
                                            ).value;
                                          const input1 =
                                            document.getElementById(
                                              "lastName"
                                            ).value;
                                          const email =
                                            document.getElementById(
                                              "email"
                                            ).value;
                                          console.log(
                                            "Input 2 (firstName):",
                                            input2
                                          );
                                          console.log(
                                            "Input 1 (lastName):",
                                            input1
                                          );
                                          $state.firstNameInputValue = input2;
                                          $state.lastNameInputValue = input1;
                                          $state.emailInputValue = email;
                                          console.log(
                                            "state of first name input: ",
                                            $state.firstNameInputValue
                                          );
                                          console.log(
                                            "state of last name input: ",
                                            $state.lastNameInputValue
                                          );
                                          console.log(
                                            "emiail",
                                            $state.emailInputValue
                                          );
                                          console.log(
                                            "is checked yes: ",
                                            $state.isCheckedYes
                                          );
                                          console.log(
                                            "is checked no: ",
                                            $state.isCheckedNo
                                          );
                                          let title;
                                          let credentials;
                                          if ($state.isCheckedYes === true) {
                                            console.log("yes is clicked");
                                            title =
                                              document.getElementById(
                                                "titleId"
                                              ).value;
                                            credentials =
                                              document.getElementById(
                                                "credentialsId"
                                              ).value;
                                            $state.yesNoError = "normal";
                                          } else if (
                                            $state.isCheckedNo === true
                                          ) {
                                            console.log("no button clicked");
                                            $state.yesNoError = "normal";
                                          } else if (
                                            $state.isCheckedYes === false &&
                                            $state.isCheckedNo === false
                                          ) {
                                            console.log(
                                              "no button is not clciked nor yes button"
                                            );
                                            $state.yesNoError = "error";
                                            $state.yesNoHelperTextOn = true;
                                            $state.yesNoHelperText =
                                              "You have to click yes or no.";
                                          }
                                          console.log(
                                            "Credential: ",
                                            credentials
                                          );
                                          let firstNameErrors = [];
                                          const firstVal =
                                            $state.firstNameInputValue;
                                          if (firstVal === "") {
                                            $state.firstNameVariant = "error";
                                            firstNameErrors.push(
                                              "First name is empty"
                                            );
                                          }
                                          if (firstNameErrors.length > 0) {
                                            $state.firstNameHelperTextOn = true;
                                            $state.firstNameVariant = "error";
                                            $state.firstNameHelperText =
                                              firstNameErrors.join("\n");
                                            console.log(
                                              "\u274C First name validation errors:",
                                              firstNameErrors
                                            );
                                          } else {
                                            $state.firstNameHelperTextOn = false;
                                            $state.firstNameVariant = "normal";
                                            $state.firstNameHelperText = "";
                                            console.log(
                                              "\u2705 First name passed all checks"
                                            );
                                            $state.firstNameValid = true;
                                          }
                                          $state.firstNameCheck =
                                            firstNameErrors.length === 0;
                                          let lastNameErrors = [];
                                          const lastVal =
                                            $state.lastNameInputValue;
                                          if (lastVal === "") {
                                            $state.lastNameVariant = "error";
                                            lastNameErrors.push(
                                              "Last name is empty"
                                            );
                                          }
                                          if (lastNameErrors.length > 0) {
                                            $state.lastNameHelperTextOn = true;
                                            $state.lastNameVariant = "error";
                                            $state.lastNameHelperText =
                                              lastNameErrors.join("\n");
                                            console.log(
                                              "\u274C Last name validation errors:",
                                              lastNameErrors
                                            );
                                          } else {
                                            $state.lastNameHelperTextOn = false;
                                            $state.lastNameHelperText = "";
                                            $state.lastNameVariant = "normal";
                                            console.log(
                                              "\u2705 Last name passed all checks"
                                            );
                                            $state.lastNameValid = true;
                                          }
                                          $state.lastNameCheck =
                                            lastNameErrors.length === 0;
                                          let emailErrors = [];
                                          const emailVal =
                                            $state.emailInputValue;
                                          if (emailVal === "") {
                                            $state.emailVariant = "error";
                                            emailErrors.push("Email is empty");
                                          }
                                          const emailPattern =
                                            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                          if (
                                            emailVal !== "" &&
                                            !emailPattern.test(emailVal)
                                          ) {
                                            $state.emailVariant = "error";
                                            emailErrors.push(
                                              "Invalid email format"
                                            );
                                          }
                                          console.log(
                                            "emailErrors",
                                            emailErrors
                                          );
                                          if (emailErrors.length > 0) {
                                            $state.emailHelperTextOn = true;
                                            $state.emailVariant = "error";
                                            $state.emailHelperText =
                                              emailErrors.join("\n");
                                            console.log(
                                              "\u274C Email validation errors:",
                                              emailErrors
                                            );
                                          } else {
                                            $state.emailHelperTextOn = false;
                                            $state.emailHelperText = "";
                                            $state.emailVariant = "normal";
                                            console.log(
                                              "\u2705 Email passed all checks"
                                            );
                                            $state.emailValid = true;
                                          }
                                          return ($state.emailCheck =
                                            emailErrors.length === 0);
                                        })();
                                      }
                                    };
                                    return (({ customFunction }) => {
                                      return customFunction();
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["runCode"] != null &&
                                typeof $steps["runCode"] === "object" &&
                                typeof $steps["runCode"].then === "function"
                              ) {
                                $steps["runCode"] = await $steps["runCode"];
                              }
                              $steps["backend"] = true
                                ? (() => {
                                    const actionArgs = {
                                      customFunction: async () => {
                                        return (async () => {
                                          const input2 =
                                            document.getElementById(
                                              "firstName"
                                            ).value;
                                          const input1 =
                                            document.getElementById(
                                              "lastName"
                                            ).value;
                                          const email =
                                            document.getElementById(
                                              "email"
                                            ).value;
                                          const yesState = $state.isCheckedYes;
                                          const noState = $state.isCheckedNo;
                                          const firstVal =
                                            $state.firstNameInputValue;
                                          const lastVal =
                                            $state.lastNameInputValue;
                                          const emailVal =
                                            $state.emailInputValue;
                                          console.log("yesState: ", yesState);
                                          console.log("nostate: ", noState);
                                          var emailvalidationcheck;
                                          const emailPattern =
                                            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                          if (
                                            emailVal !== "" &&
                                            !emailPattern.test(emailVal)
                                          ) {
                                            emailvalidationcheck = false;
                                          } else {
                                            emailvalidationcheck = true;
                                          }
                                          console.log(
                                            "email validation check backend code: ",
                                            emailvalidationcheck
                                          );
                                          let title;
                                          let credentials;
                                          if (
                                            $state.isCheckedYes === "clicked"
                                          ) {
                                            title =
                                              document.getElementById(
                                                "titleId"
                                              ).value;
                                            credentials =
                                              document.getElementById(
                                                "credentialsId"
                                              ).value;
                                          }
                                          const payload = {
                                            firstName: input2,
                                            lastName: input1,
                                            email: email,
                                            title: title,
                                            credentials: credentials,
                                            isCheckedYes: yesState,
                                            isCheckedNo: noState,
                                            validatedFirstName: firstVal,
                                            validatedLastName: lastVal,
                                            validatedEmail: emailVal
                                          };
                                          console.log(
                                            "Sending payload:",
                                            payload
                                          );
                                          console.log(
                                            "page status 1: ",
                                            $state.showFormStatus
                                          );
                                          return fetch(
                                            "https://opformypractice.com/api/signup_one_step/",
                                            {
                                              method: "POST",
                                              headers: {
                                                "Content-Type":
                                                  "application/json"
                                              },
                                              body: JSON.stringify(payload)
                                            }
                                          )
                                            .then(async res => {
                                              const data = await res
                                                .json()
                                                .catch(() => null);
                                              if (!res.ok) {
                                                console.error(
                                                  `❌ Server error (${res.status}):`,
                                                  data || res.statusText
                                                );
                                                console.log(
                                                  "page status 2: ",
                                                  $state.showFormStatus
                                                );
                                                $state.showFormStatus = false;
                                                console.log(
                                                  "page status 3: ",
                                                  $state.showFormStatus
                                                );
                                                return;
                                              }
                                              if (
                                                emailvalidationcheck === true
                                              ) {
                                                console.log(
                                                  "\u2705 Response from backend:",
                                                  data
                                                );
                                                $state.showFormStatus = true;
                                                console.log(
                                                  "page status 4: ",
                                                  $state.showFormStatus
                                                );
                                              }
                                            })
                                            .catch(err => {
                                              console.error(
                                                "\uD83D\uDEA8 Network or fetch error:",
                                                err
                                              );
                                              $state.showFormStatus = false;
                                              console.log(
                                                "page status 5: ",
                                                $state.showFormStatus
                                              );
                                            });
                                        })();
                                      }
                                    };
                                    return (({ customFunction }) => {
                                      return customFunction();
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["backend"] != null &&
                                typeof $steps["backend"] === "object" &&
                                typeof $steps["backend"].then === "function"
                              ) {
                                $steps["backend"] = await $steps["backend"];
                              }
                            }}
                            showIcon={false}
                            size={"medium"}
                            ststus={"normal"}
                            type={"button"}
                          />
                        }
                        className={classNames(
                          "__wab_instance",
                          sty.inputFormShell
                        )}
                        fieldsSlot={
                          <React.Fragment>
                            <FormElement
                              className={classNames(
                                "__wab_instance",
                                sty.formElement__jvrzc
                              )}
                              formInputComponent={
                                <InputField
                                  className={classNames(
                                    "__wab_instance",
                                    sty.inputField__yMltx
                                  )}
                                  inputId={"firstName"}
                                  placeholder={``}
                                  status={(() => {
                                    try {
                                      return $state.firstNameVariant;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "normal";
                                      }
                                      throw e;
                                    }
                                  })()}
                                  type={"text"}
                                  valueInput={(() => {
                                    try {
                                      return $state.firstNameInputValue;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              helperText={(() => {
                                try {
                                  return $state.firstNameHelperText;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                              label={"first name."}
                              name={``}
                              required={true}
                              showHelperText={(() => {
                                try {
                                  return $state.firstNameHelperTextOn;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              showRequired={true}
                              status={(() => {
                                try {
                                  return $state.firstNameVariant;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "normal";
                                  }
                                  throw e;
                                }
                              })()}
                            />

                            <FormElement
                              className={classNames(
                                "__wab_instance",
                                sty.formElement__lfG8Z
                              )}
                              formInputComponent={
                                <InputField
                                  className={classNames(
                                    "__wab_instance",
                                    sty.inputField__zhiuk
                                  )}
                                  inputId={"lastName"}
                                  placeholder={``}
                                  status={(() => {
                                    try {
                                      return $state.lastNameVariant;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "normal";
                                      }
                                      throw e;
                                    }
                                  })()}
                                  type={"text"}
                                  valueInput={(() => {
                                    try {
                                      return $state.lastNameInputValue;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              helperText={(() => {
                                try {
                                  return $state.lastNameHelperText;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                              label={"last name."}
                              name={``}
                              required={true}
                              showHelperText={(() => {
                                try {
                                  return $state.lastNameHelperTextOn;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              showRequired={true}
                              status={(() => {
                                try {
                                  return $state.lastNameVariant;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "normal";
                                  }
                                  throw e;
                                }
                              })()}
                            />

                            <FormElement
                              className={classNames(
                                "__wab_instance",
                                sty.formElement__lb3Lr
                              )}
                              formInputComponent={
                                <InputField
                                  className={classNames(
                                    "__wab_instance",
                                    sty.inputField___8AZbV
                                  )}
                                  inputId={"email"}
                                  placeholder={``}
                                  status={(() => {
                                    try {
                                      return $state.emailVariant;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "normal";
                                      }
                                      throw e;
                                    }
                                  })()}
                                  type={"email"}
                                  valueInput={(() => {
                                    try {
                                      return $state.emailInputValue;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              helperText={(() => {
                                try {
                                  return $state.emailHelperText;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                              label={"email."}
                              name={``}
                              required={true}
                              showFormElement={true}
                              showHelperText={(() => {
                                try {
                                  return $state.emailHelperTextOn;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              showRequired={true}
                              status={(() => {
                                try {
                                  return $state.emailVariant;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "normal";
                                  }
                                  throw e;
                                }
                              })()}
                            />

                            <FormElement
                              className={classNames(
                                "__wab_instance",
                                sty.formElement__fPfr8
                              )}
                              formInputComponent={
                                <RadioGroup
                                  data-plasmic-name={"radioGroup"}
                                  data-plasmic-override={overrides.radioGroup}
                                  className={classNames(
                                    "__wab_instance",
                                    sty.radioGroup
                                  )}
                                  radioOptionsSlot={
                                    <React.Fragment>
                                      <RadioOption
                                        className={classNames(
                                          "__wab_instance",
                                          sty.radioOption__tDgzu
                                        )}
                                        valueShown={"Yes."}
                                      >
                                        <RadioButtonSeparateComp
                                          className={classNames(
                                            "__wab_instance",
                                            sty.radioButtonSeparateComp__kFee2
                                          )}
                                          onClick={async () => {
                                            const $steps = {};
                                            $steps["runCode"] = true
                                              ? (() => {
                                                  const actionArgs = {
                                                    customFunction:
                                                      async () => {
                                                        return (() => {
                                                          $state.yesNoClickCount =
                                                            $state.yesNoClickCount +
                                                            1;
                                                          if (
                                                            $state.yesNoClickCount %
                                                              2 !==
                                                            0
                                                          ) {
                                                            $state.isCheckedYes =
                                                              "clicked";
                                                            $state.isCheckedNo =
                                                              "notclicked";
                                                            $state.showTitleCredentials = true;
                                                          } else {
                                                            $state.isCheckedYes =
                                                              "notclicked";
                                                          }
                                                          return console.log(
                                                            "click count value:",
                                                            $state.yesClickCount
                                                          );
                                                        })();
                                                      }
                                                  };
                                                  return (({
                                                    customFunction
                                                  }) => {
                                                    return customFunction();
                                                  })?.apply(null, [actionArgs]);
                                                })()
                                              : undefined;
                                            if (
                                              $steps["runCode"] != null &&
                                              typeof $steps["runCode"] ===
                                                "object" &&
                                              typeof $steps["runCode"].then ===
                                                "function"
                                            ) {
                                              $steps["runCode"] =
                                                await $steps["runCode"];
                                            }
                                          }}
                                          status={(() => {
                                            try {
                                              return $state.isCheckedYes;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "notclicked";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        />
                                      </RadioOption>
                                      <RadioOption
                                        className={classNames(
                                          "__wab_instance",
                                          sty.radioOption__ku3Pn
                                        )}
                                        valueShown={"No."}
                                      >
                                        <RadioButtonSeparateComp
                                          className={classNames(
                                            "__wab_instance",
                                            sty.radioButtonSeparateComp__kwDjY
                                          )}
                                          onClick={async () => {
                                            const $steps = {};
                                            $steps["runCode"] = true
                                              ? (() => {
                                                  const actionArgs = {
                                                    customFunction:
                                                      async () => {
                                                        return (() => {
                                                          $state.yesNoClickCount =
                                                            $state.yesNoClickCount +
                                                            1;
                                                          if (
                                                            $state.yesNoClickCount %
                                                              2 ===
                                                            0
                                                          ) {
                                                            $state.isCheckedNo =
                                                              "clicked";
                                                            $state.isCheckedYes =
                                                              "notclicked";
                                                            return ($state.showTitleCredentials = false);
                                                          } else {
                                                            return ($state.isCheckedNo =
                                                              "notclicked");
                                                          }
                                                        })();
                                                      }
                                                  };
                                                  return (({
                                                    customFunction
                                                  }) => {
                                                    return customFunction();
                                                  })?.apply(null, [actionArgs]);
                                                })()
                                              : undefined;
                                            if (
                                              $steps["runCode"] != null &&
                                              typeof $steps["runCode"] ===
                                                "object" &&
                                              typeof $steps["runCode"].then ===
                                                "function"
                                            ) {
                                              $steps["runCode"] =
                                                await $steps["runCode"];
                                            }
                                          }}
                                          status={(() => {
                                            try {
                                              return $state.isCheckedNo;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return "notclicked";
                                              }
                                              throw e;
                                            }
                                          })()}
                                        />
                                      </RadioOption>
                                    </React.Fragment>
                                  }
                                />
                              }
                              helperText={(() => {
                                try {
                                  return $state.yesNoHelperText;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                              label={"are you a licensed clinician?"}
                              name={``}
                              required={true}
                              showHelperText={(() => {
                                try {
                                  return $state.yesNoHelperTextOn;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })()}
                              showRequired={true}
                              status={(() => {
                                try {
                                  return $state.yesNoError;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "normal";
                                  }
                                  throw e;
                                }
                              })()}
                            />

                            {(() => {
                              try {
                                return $state.showTitleCredentials;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <div
                                data-plasmic-name={"wrapper"}
                                data-plasmic-override={overrides.wrapper}
                                className={classNames(
                                  projectcss.all,
                                  sty.wrapper
                                )}
                              >
                                <FormElement
                                  className={classNames(
                                    "__wab_instance",
                                    sty.formElement__t3V0H
                                  )}
                                  formInputComponent={
                                    <InputField
                                      className={classNames(
                                        "__wab_instance",
                                        sty.inputField__qoGs
                                      )}
                                      inputId={"titleId"}
                                      placeholder={'"Dr."'}
                                      status={"normal"}
                                      type={"text"}
                                      valueInput={"Dr."}
                                    />
                                  }
                                  helperText={``}
                                  label={"title."}
                                  name={``}
                                  required={false}
                                  showHelperText={false}
                                  status={"normal"}
                                />

                                <FormElement
                                  className={classNames(
                                    "__wab_instance",
                                    sty.formElement__jGy9X
                                  )}
                                  formInputComponent={
                                    <InputField
                                      className={classNames(
                                        "__wab_instance",
                                        sty.inputField__tebi2
                                      )}
                                      inputId={"credentialsId"}
                                      placeholder={'"DDS", "DDM"'}
                                      status={"normal"}
                                      type={"text"}
                                    />
                                  }
                                  helperText={``}
                                  label={"credentials."}
                                  name={``}
                                  required={false}
                                  showHelperText={false}
                                  status={"normal"}
                                />
                              </div>
                            ) : null}
                          </React.Fragment>
                        }
                        layout={"_default"}
                      />
                    }
                    infotextWrapper2={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__lgPIn
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {"Already have an account? "}
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                            }
                            style={{ color: "var(--token-jyNQAasUGv4X)" }}
                          >
                            {"[ "}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <PlasmicLink__
                              data-plasmic-name={"link"}
                              data-plasmic-override={overrides.link}
                              className={classNames(
                                projectcss.all,
                                projectcss.a,
                                projectcss.a__fRuRb,
                                projectcss.__wab_text,
                                projectcss.plasmic_default__inline,
                                sty.link
                              )}
                              href={`/login`}
                              platform={"react"}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                                  }
                                  style={{ color: "var(--token-jyNQAasUGv4X)" }}
                                >
                                  {"log in"}
                                </span>
                              </React.Fragment>
                            </PlasmicLink__>
                          }
                          <React.Fragment>{""}</React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                            }
                            style={{ color: "var(--token-jyNQAasUGv4X)" }}
                          >
                            {" ]"}
                          </span>
                        </React.Fragment>
                      </div>
                    }
                    onContainerChange={async (...eventArgs) => {
                      generateStateOnChangeProp($state, [
                        "onboardingContainer",
                        "container"
                      ]).apply(null, eventArgs);
                      if (
                        eventArgs.length > 1 &&
                        eventArgs[1] &&
                        eventArgs[1]._plasmic_state_init_
                      ) {
                        return;
                      }
                    }}
                    showFormStatus={(() => {
                      try {
                        return $state.showFormStatus;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()}
                    showHeader={true}
                    showHelperText={false}
                    text={
                      <React.Fragment>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__nSs1E
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {"We\u2019ve sent a message with a link to "}
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__fRuRb"
                              }
                              style={{ color: "#000000", fontWeight: 600 }}
                            >
                              {"john@email.com"}
                            </span>
                            <React.Fragment>
                              {" to verify your email."}
                            </React.Fragment>
                          </React.Fragment>
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__w3O5O
                          )}
                        >
                          {
                            "This link expires in 24 hours.\nDidn't receive an email? Check your spam folder."
                          }
                        </div>
                      </React.Fragment>
                    }
                    text2={
                      <React.Fragment>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__ijWQm
                          )}
                        >
                          {"that\u2019s it, you\u2019re in."}
                        </div>
                        {false ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___7ViA6
                            )}
                          >
                            {"You\u2019ve successfully created you OP account."}
                          </div>
                        ) : null}
                      </React.Fragment>
                    }
                  >
                    <ButtonPrimary
                      color={"brand"}
                      content={"try again"}
                      size={"medium"}
                      ststus={"normal"}
                      type={"button"}
                    />
                  </NativeContainer>
                </React.Fragment>
              }
              tabNav={
                <WebTopNav
                  data-plasmic-name={"webTopNav"}
                  data-plasmic-override={overrides.webTopNav}
                  className={classNames("__wab_instance", sty.webTopNav)}
                  pageButtons={
                    <ButtonSecondary
                      data-plasmic-name={"buttonSecondary"}
                      data-plasmic-override={overrides.buttonSecondary}
                      className={classNames(
                        "__wab_instance",
                        sty.buttonSecondary
                      )}
                      color={"primary"}
                      content={"x"}
                      onClick={async () => {
                        const $steps = {};
                        $steps["goToWebWorkspace"] = true
                          ? (() => {
                              const actionArgs = { destination: `/workspace` };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  location.assign(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToWebWorkspace"] != null &&
                          typeof $steps["goToWebWorkspace"] === "object" &&
                          typeof $steps["goToWebWorkspace"].then === "function"
                        ) {
                          $steps["goToWebWorkspace"] =
                            await $steps["goToWebWorkspace"];
                        }
                      }}
                    />
                  }
                  pageTitle={
                    <Breadcrumb
                      data-plasmic-name={"breadcrumb"}
                      data-plasmic-override={overrides.breadcrumb}
                      className={classNames("__wab_instance", sty.breadcrumb)}
                      crumbCount={"justTitle"}
                      sidePadding={"_default"}
                      size={"navS"}
                      tabTitle={"o21p signup."}
                    />
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  page: [
    "page",
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "buttonSecondary",
    "progressBar",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  appShell: [
    "appShell",
    "webTab",
    "webTopNav",
    "breadcrumb",
    "buttonSecondary",
    "progressBar",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  webTab: [
    "webTab",
    "webTopNav",
    "breadcrumb",
    "buttonSecondary",
    "progressBar",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  webTopNav: ["webTopNav", "breadcrumb", "buttonSecondary"],
  breadcrumb: ["breadcrumb"],
  buttonSecondary: ["buttonSecondary"],
  progressBar: ["progressBar"],
  onboardingContainer: [
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  inputFormShell: ["inputFormShell", "radioGroup", "wrapper"],
  radioGroup: ["radioGroup"],
  wrapper: ["wrapper"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebSignupTemp__ArgProps,
          internalVariantPropNames: PlasmicWebSignupTemp__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebSignupTemp__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "page") {
    func.displayName = "PlasmicWebSignupTemp";
  } else {
    func.displayName = `PlasmicWebSignupTemp.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "fRuRbcdHVNMtdcnFK96ivt"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicWebSignupTemp = Object.assign(
  // Top-level PlasmicWebSignupTemp renders the root element
  withUsePlasmicAuth(makeNodeComponent("page")),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    webTab: makeNodeComponent("webTab"),
    webTopNav: makeNodeComponent("webTopNav"),
    breadcrumb: makeNodeComponent("breadcrumb"),
    buttonSecondary: makeNodeComponent("buttonSecondary"),
    progressBar: makeNodeComponent("progressBar"),
    onboardingContainer: makeNodeComponent("onboardingContainer"),
    inputFormShell: makeNodeComponent("inputFormShell"),
    radioGroup: makeNodeComponent("radioGroup"),
    wrapper: makeNodeComponent("wrapper"),
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicWebSignupTemp
    internalVariantProps: PlasmicWebSignupTemp__VariantProps,
    internalArgProps: PlasmicWebSignupTemp__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/signup",
      pagePath: "/signup",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWebSignupTemp;
/* prettier-ignore-end */
